import React, { useEffect, useState } from "react";
import { Inputs, Tabbles } from "../../../components";
import { PiPlus, PiTrash } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { useToast } from "../../../contexts";
import { MdOutlineMedicalServices } from "react-icons/md";
import { useTranslation } from "react-i18next";

const AddAdditionalServices = ({ loginData, credentials, setCredentials, appointment }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const dispatch = useDispatch();
    const [showServices, setShowServices] = useState(false);
    const getAllAdditionalServicesData = useSelector(
        (state) => state.doctor.getAllAdditionalServicesData?.data
    );

    const getAdditionalServiceInfoData = useSelector(
        (state) => state.doctor.getAdditionalServiceInfoData?.data
    );

    useEffect(() => {
        if (getAdditionalServiceInfoData?.result?.servicesModel?.length) {
            setCredentials((prev) => {
                const selectedServices = getAdditionalServiceInfoData.result.servicesModel.map(service => ({
                    serviceGuid: service.serviceGuid,
                    appointmentGuid: getAdditionalServiceInfoData.result.servicesModel[0].appointmentGuid
                }));

                return {
                    ...prev,
                    appointmentAdditionalServiceModel: selectedServices
                };
            });
        }
    }, [getAdditionalServiceInfoData, setCredentials]);

    const handleServiceChange = (serviceGuid) => {
        setCredentials((prev) => {
            let updatedServices = [...prev.appointmentAdditionalServiceModel];
            updatedServices = updatedServices.filter(service => service.serviceGuid);
            const isServiceSelected = updatedServices.some(service => service.serviceGuid === serviceGuid);
            if (isServiceSelected) {
                updatedServices = updatedServices.filter(service => service.serviceGuid !== serviceGuid);
            } else {
                updatedServices.push({ serviceGuid, appointmentGuid: prev.appDetail.appointmentGuid });
            }
            const updatedCredentials = {
                appointmentGuid: prev.appDetail.appointmentGuid,
                additionalServiceData: updatedServices.map(service => ({ serviceGuid: service.serviceGuid }))
            };

            dispatch(actionDoctor.postAdditionalServices(updatedCredentials, (error, response) => {
                if (error) {
                    console.error("Error posting additional services:", error);
                } else {
                    showToast(
                        `${t("success")}`,
                        `${t("doctor.diagnostic_report.successfully_posted_additional_services")}`,
                        5000,
                        true,
                        "top-end toast-success"
                    );

                    dispatch(
                        actionDoctor.getAdditionalServiceInfo(appointment?.appointmentGuid, loginData?.currencyCode)
                    );




                }
            }));

            return { ...prev, appointmentAdditionalServiceModel: updatedServices };
        });
    };


    return (
        <div className="add-additional-services">
            <div className="position-relative add-add-services" >
                <Inputs.FormInputs
                    type="search"
                    className="form-control"
                    placeholder={t("visiting_schedule.add_services")}
                    inputIcons={<></>}
                />
                <div className="aa-input-icn" onClick={() => setShowServices(!showServices)}>
                    <PiPlus className="icnplus" />
                </div>
            </div>

            {showServices && (
                <ul className="list-group">
                    {getAllAdditionalServicesData?.result.map((items, index) => {
                        const isChecked = credentials?.appointmentAdditionalServiceModel?.some(
                            (service) => service.serviceGuid === items.serviceGuid
                        );

                        return (
                            <li className="list-group-item exado_body_text_two" key={index}>
                                {items.serviceName} - {items.amount} {items.currencyCode}
                                <Inputs.CheckRadioInput
                                    type="checkbox"
                                    className="form-grp-check-toggle"
                                    checked={isChecked}
                                    onChange={() => handleServiceChange(items.serviceGuid)}
                                />
                            </li>
                        );
                    })}
                </ul>
            )}
            <Tabbles.TableBlk
                headerIcon={<MdOutlineMedicalServices className="header-Icn" />}
                heading={t("additional_services")}
                subHeading=""
                columns={[
                    `${t("services_name")}`,
                    `${t("description")}`,
                    `${t("amount")}`,
                    `${t("delete")}`,
                ]}
                data={getAdditionalServiceInfoData?.result?.servicesModel
                    ?.map((service) => ({
                        [t("services_name")]: service.serviceName,
                        [t("description")]: service.description,
                        [t("amount")]: `${service.amount} ${service.currency}`,


                        [t("delete")]: (
                            <PiTrash
                                onClick={() => handleServiceChange(service.serviceGuid)}
                                className="delIcon noVerify"
                            />
                        ),
                    }))
                }
                tabbleSectionClassname="diagnosis-add-service"
                tabbleClassname="tabble"
            />


        </div>
    );
};

export default AddAdditionalServices;
